import React, { useEffect } from "react";
import { Table } from "antd";
import { ColumnsType } from "antd/es/table";
import { useStockOutputModel } from "../stockOutputModel";
import { IStockOutputFields } from "../stockOutputService"
import useNavModel from "@/model/navModel";
import { useDictModel } from "../../../base/dict/dictModel";
import { momentFormat } from "@/utils/utils";
import useGlobalModel from "@/model/globalModel";
import zh_CN from "@/locale/zh-CN";
import en_US from "@/locale/en-US";

export function DataTable() {
    let LanguageArr: any = {
        "zh-CN": zh_CN,
        "en-US": en_US
    }
    const { language,setLocale } = useGlobalModel()
    const Locale = setLocale(LanguageArr)

    const { dataSource, selectedRowKeys, pgCfg, loadData, setSelectedRowKeys } = useStockOutputModel()
    const { selectedNavId, replaceNav } = useNavModel();
    const { getTreeNodeName,getTreeNodeOne } = useDictModel();

    useEffect(() => {
        loadData()
    }, [])
    const onLook = (text: string) => {
        console.log(text)
        replaceNav(selectedNavId, "4-4-3", { id: text as string, mode: "look" }, true);
    }
    const columns: ColumnsType<IStockOutputFields> = [
        {
            // title: '序号',
            title: Locale["SN"],
            width: 80,
            render: (text, record, index) => `${index + 1}`
        }, {
            // title: "出库单号",
            title: Locale["Stock-out Doc No."],
            width: 120,
            dataIndex: 'tradeCode',
            render: text => <span onClick={() => onLook(text)} className="click-span">{text}</span>
        }, {
            // title: '出库时间',
            title: Locale["Stock-out Time"],
            width: 160,
            dataIndex: 'stockIoTime',
        }, {
            // title: '单据类型',
            title: Locale["Document  Type"],
            width: 160,
            dataIndex: 'tradeTypeCode',
            // render: (text) => getTreeNodeName(text)
            render: (text) => {
                if (text) {
                    return language == "zh-CN" ? getTreeNodeOne(text)[0].name : getTreeNodeOne(text)[0].nameEn as string
                }else{
                    return ""
                }
            }
        }, {
            // title: '出库数量',
            title: Locale["Stock-out Qty"],
            width: 160,
            dataIndex: 'inTotal',
        }, {
            // title: '制单员',
            title: Locale["Creator"],
            width: 160,
            dataIndex: 'billingClerk',
        }, {
            // title: '制单时间',
            title: Locale["Creation Time"],
            width: 160,
            dataIndex: 'billingTime',
            render: (text) => momentFormat(text)
        }
    ];
    return (
        <Table
            style={{ cursor: "pointer" }}
            rowKey={record => record.id as string}
            rowSelection={{
                type: "radio",
                onChange: (selectedRowKeys: React.Key[], selectedRows: IStockOutputFields[]) => {
                    setSelectedRowKeys(selectedRowKeys);
                },
                selectedRowKeys
            }}
            columns={columns}
            dataSource={dataSource}
            pagination={{
                ...pgCfg,
                position: ["bottomCenter"],
                showTotal: () => `共${pgCfg.total}条`,
                onChange: (pageNum, pageSize) => {
                    loadData({ pageNum, pageSize }).then();
                }
            }}
            onRow={record => {
                return {
                    onClick: event => {
                        if (selectedRowKeys.length > 0 && selectedRowKeys[0] === record.id) {
                            setSelectedRowKeys([]);
                        } else {
                            setSelectedRowKeys([record.id as string]);
                        }
                    },
                };
            }}
            scroll={{ x: 'max-content', y: 500 }}
        />
    )
}
